// Shared text constants for the home dashboard tiles (kept out of TileShell.tsx
// so that file exports components only, per react-refresh).
export const MUTED_TEXT = 'text-amp-ink-muted dark:text-amp-dark-ink-muted';
export const NOT_AVAILABLE = 'Not available yet';
// Under Top sellers and Inventory watch. The api leaves out the Bulk category
// (bulk candy, loyalty scoops, fillable jars and refills, which hold a mix of
// products), mixed selling SKUs, and Non-sellable items such as bags.
export const EXCLUDED_ITEMS_NOTE =
  'Not included: bulk candy, fillable containers and refills, mixed selling SKUs, and store supplies like bags.';

/** Green when ahead of last year, red when behind, muted when not comparable. */
export function deltaClass(delta: number | null): string {
  if (delta == null) return MUTED_TEXT;
  return delta >= 0
    ? 'text-green-700 dark:text-green-400 font-semibold'
    : 'text-red-700 dark:text-red-400 font-semibold';
}
